// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CWJU","content":"styles_content__3xxIt"};